import React from "react";
import styled from "styled-components/macro";
import { Button } from "@material-ui/core";
import download from "../../images/unit/download.png";
import share from "../../images/unit/share.svg";
import { StyledGreyButton } from "../ButtonsStyle";

const UnitData = ({ itemsCount, onQuoteClick, onSharePress }) => {
  return (
    <Wrapper>
      <Section style={{ padding: "15px", height: "100%", overflow: "auto" }}>
        <Section style={{ overflow: "auto" }}>
          <span
            style={{
              textDecoration: "underline",
              lineHeight: 2,
              fontSize: "18px",
            }}
          >
            Product list
          </span>

          <ItemsWrapper>
            {Object.keys(itemsCount).map((key, index) => {
              if (key === "Shop") {
                return null;
              }
              return (
                <ItemText key={index}>
                  <img
                    style={{ objectFit: "contain" }}
                    width={55}
                    height={55}
                    src={itemsCount[key].item.image}
                    alt={"item"}
                  />
                  <div style={{ marginLeft: "10px" }}>
                    <div style={{ marginBottom: "4px" }}>
                      <Span>{`${key}: `}</Span>
                      <Span>{itemsCount[key].count}</Span>
                    </div>
                    <Span
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {itemsCount[key].item.model}
                    </Span>
                  </div>
                </ItemText>
              );
            })}
          </ItemsWrapper>
        </Section>
        <Button
          variant="outlined"
          style={{ marginTop: "10px", height: "80px", color: "#4b4b4b" }}
          onClick={() => {}}
        >
          <ButtonTextWrapper>
            <img width={17} height={18} src={download} alt={"download"} />
            <span style={{ marginRight: "10px" }}>Products List and Plans</span>
          </ButtonTextWrapper>
        </Button>
      </Section>
      <GraySection>
        <StyledGreyButton onClick={onQuoteClick} variant="contained">
          Get a quote!
        </StyledGreyButton>
        <div
          onClick={onSharePress}
          style={{
            cursor: "pointer",
            display: "flex",
            marginTop: "15px",
            alignItems: "center",
            color: "#FFFFFF",
            fontSize: "20px",
            fontFamily: " Manrope,serif",
          }}
        >
          <div>{"Share"}</div>
          <img
            style={{ marginLeft: "7px" }}
            width={20}
            height={20}
            src={share}
            alt={"share"}
          />
        </div>
      </GraySection>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  color: #707070;
  position: relative;
  flex-direction: column;
  border-radius: 25px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: white;
  height: 100%;
  max-width: 300px;
`;

const ButtonTextWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
`;

const Section = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
`;

const GraySection = styled.div`
  color: white;
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  background-color: #606060;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
`;

const ItemText = styled.div`
  position: relative;
  flex-direction: row;
  align-self: start;
  align-items: center;
  height: 70px;
  display: flex;
  border-bottom: 1px solid #dcdcdc;
`;

const ItemsWrapper = styled.div`
  position: relative;
  overflow-y: scroll;
`;

const Span = styled.span`
  font-family: Manrope, serif;
  line-height: 1.2;
  font-size: 14px;
  color: #707070;
`;

export { UnitData };
